import { AutocompleteState, BaseItem, createAutocomplete } from "@algolia/autocomplete-core";
import { createContext } from "react";

type AlgoliaContextType = {
  autocompleteState: AutocompleteState<BaseItem> | null;
  autocomplete: ReturnType<typeof createAutocomplete<BaseItem>>;
};

export const AlgoliaContext = createContext<AlgoliaContextType | null>(null);
